<template>
  <div class="block" style="margin-bottom: -6px">
    <video
      src="../assets/videos/hands.mp4"
      autoplay
      loop
      muted
      defaultMuted
      playsinline
    ></video>

    <div class="container position-absolute top-50 start-50 translate-middle">
      <h1 v-if="viewStore.isMobile" class="text-center header-title pb-5 fs-6">
        Unsere Kompetenzen
      </h1>

      <h1 v-else class="text-center header-title pb-2">Unsere Kompetenzen</h1>
      <h2 class="sub-title text-center pb-5">
        Das Hörvermögen, das du verdienst.
      </h2>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-4 pb-5">
        <!-- Loop -->
        <div
          v-for="(skill, index) in skills[viewStore.selfOrCompany]"
          :key="index"
          class="col pb-4"
        >
          <div
            class="card rounded-3"
            style="min-height: 250px"
            @mouseenter="openSkill(index)"
            @mouseleave="closeSkill(index)"
          >
            <div class="card-body">
              <div
                v-if="showSkill !== index"
                class="d-flex h-100 justify-content-center"
              >
                <h3 class="card-title-closed align-self-center text-center p-2">
                  {{ skill.header }}
                </h3>
              </div>

              <div v-else class="open-card">
                <h5 class="card-title">{{ skill.header }}</h5>
                <p class="card-text">
                  {{ skill.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();

const showSkill = ref(null);

const openSkill = (index) => {
  showSkill.value = index;
};
const closeSkill = () => {
  showSkill.value = null;
};

const skills = ref({
  self: [
    {
      header: "Social Content",
      description:
        "Wir verwandeln deinen Podcast in ansprechenden Social Media Content, Newsletter oder deinen Blog. Damit du gehört UND gesehen wirst.",
    },
    {
      header: "Distribution",
      description:
        "Die Veröffentlichung ist neben der Produktion eine der entscheidend-sten Komponenten im Podcasting. Wir kümmern uns um deine Veröffentlichung und sorgen mit smarten SEO-Strategien für maximale Reichweite auf allen Plattformen.",
    },
    {
      header: "Audio Branding",
      description:
        "It's a match! Wir kreieren und gestalten einzigartige Intros, kreative Jingles und maßgeschneiderte Soundelemente, die perfekt auf deine Marke abgestimmt ist und sich mit deiner Zielgruppe & Hörerschaft identifiziert.",
    },
    {
      header: "Werbung",
      description:
        "Ohne Moos nix los. Wir beraten dich bei Anfragen für Werbekooperationen, unterstützen beim Reporting und der technischen Umsetzung von Werbung im Podcast.",
    },
    {
      header: "Konzepte",
      description:
        "Wir entwickeln ganzheitliche Konzepte. Von der Themenfindung, über die Marktanalyse bis hin zur Formatgestaltung. Zusätzlich bieten wir crossmediale Beratung, damit deinem Podcast noch mehr Reichweite generiert.",
    },
    {
      header: "Management",
      description:
        "Lean back - Wir behalten den Überblick. Von der Planung, über die Veröffentlichung, bis hin zum Gäste-Management. Wir betreuen dich ganzheitlich und sorgen dafür, dass alle Prozesse nahtlos zusammen laufen.",
    },
    {
      header: "Aufnahme & Technik",
      description:
        "Die perfekte Mikrofonwahl, das beste Set-up für deine Stimme und die deiner Gäste und schnelle Lösungen bei Technikfragen. Bei uns klingst du immer richtig.",
    },
    {
      header: "Reporting & Analyse",
      description:
        "Hörer, Schneller, Weiter! In unseren persönlichen 1:1 Sessions analysieren wir deinen Erfolg. Wir tüfteln gemeinsam an Strategien, damit dein Podcast wachsen darf.",
    },
  ],
  company: [
    {
      header: "Konzeption",
      description:
        "Wir beraten für ein modernes & langfristiges Podcast Format, welches eure Inhalte zum Ausdruck bringt, eure Werte vermittelt und die Zielgruppe erreicht, die sich mit euch identifiziert.",
    },
    {
      header: "Umsetzung",
      description:
        "Wir unterstützen euch bei der technischen Umsetzung des Podcasts. Wir geben euch smarte und lösungsorientierte Tools mit an die Hand, mit denen ihr und eure Mitarbiter*in sich wohl fühlt.",
    },
    {
      header: "Aufnahme",
      description:
        "Wir beraten euch für eine perfekte Aufnahmequalität und liefern euch bestmögliche Podcastfolgen durch unsere langjährige Erfahrung in der Post-Produktion.",
    },
    {
      header: "Sound-Design",
      description:
        "Wir schaffen Atmosphäre! Durch maßgeschneiderte Musik, kreatives Sound-Design oder Inhouse produzierte Jingles. Wir liefern euch einen individuellen Sound, der euren Podcast mit eurer Zielgruppe verbindet.",
    },
    {
      header: "Monetarisierung",
      description:
        "Sponsoring, Native Adds oder Audio-Spots? Mit unserer Expertise  begleiten wir dich bei der Suche passender Werbepartner und bieten ideale Lösungen für die Monetarisierung deines Podcasts.",
    },
    {
      header: "Innovativ",
      description:
        "Moderne Podcasts sind keine Einbahnstraße! Wir zeigen euch, wie man kreative Feedback-Kanäle aufbaut und dadurch mehr Interaktivität mit eurer Zuhörerschaft erreicht.",
    },
    {
      header: "Reporting",
      description:
        "Eure Podcastzahlen immer im Blick! Kontinuierlich bereiten wir das Reporting für euren Podcast auf. Wir analysieren die wichtigsten Zahlen und geben euch konkrete Handlungsempfehlungen mit an die Hand.",
    },
    {
      header: "Content Recycling",
      description:
        "Was wertvoll ist, soll bestmöglich verwertet werden. Von Transkription bis zur Erstellung von Videoclips: Aus dem, was deine Podcastfolge an Content bietet, kreieren wir Social Media Teaser, Quotes, Videoformate für YouTube und vieles mehr.",
    },
  ],
});
</script>

<style scoped>
.header-title {
  color: #fc4667;
  font-weight: 900;
  font-size: 3.5rem;
}
.block {
  position: relative;
  /* bottom: 0; */
  width: 100%;
  height: 100%;
}

.card-title {
  color: black !important;
  font-weight: 700;
  /* font-family: "Josefin Sans", sans-serif; */
}

.card-title-closed {
  color: black !important;
  font-weight: 700;
  /* font-family: "Josefin Sans", sans-serif; */
}

.open-card {
  transition: 0.5s;
}

.card-body:hover {
  cursor: pointer;
  transition-duration: 0.5;
}

.card {
  height: 100%;
  border: none;
  background-color: rgba(255, 255, 255, 0.66);
}

.card:hover {
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0.5rem 1rem rgba(var(--bs-body-color-rgb), 0.15) !important;
  transition-duration: 0.5;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.sub-title {
  color: rgb(169, 168, 168);
  font-weight: 200;
  font-size: 1.75rem;
}
</style>
